import { z } from 'zod';
export const CAP_STATUSES = ['original', 'replaced', 'leaking', 'removed', 'not_applicable'];
export const CAP_TYPES = ['electrolytic', 'ceramic', 'film', 'tantalum', 'other'];
export const capacitorEntrySchema = z.object({
    designator: z.string().min(1).max(20),
    value: z.string().max(50).optional().default(''),
    voltage: z.string().max(20).optional().default(''),
    type: z.enum(CAP_TYPES).default('electrolytic'),
    status: z.enum(CAP_STATUSES).default('original'),
    replacedDate: z.string().nullable().optional(),
    notes: z.string().max(500).optional().default(''),
    posX: z.number().min(0).max(100).optional(),
    posY: z.number().min(0).max(100).optional(),
});
export const createCapacitorMapSchema = z.object({
    boardRevision: z.string().max(100).optional().default(''),
    capacitors: z.array(capacitorEntrySchema).default([]),
    notes: z.string().max(2000).optional().default(''),
});
export const updateCapacitorMapSchema = createCapacitorMapSchema.partial();
export const updateCapStatusSchema = z.object({
    status: z.enum(CAP_STATUSES),
    replacedDate: z.string().nullable().optional(),
    notes: z.string().max(500).optional(),
});
//# sourceMappingURL=capacitorMap.js.map